import React from 'react';

export const AnalyticsPage = () => {
    return <div>AnalyticsPage</div>;
};
